$('.tiles__more button').click(function() {
    $(this).fadeOut(300).closest('.tiles').find('.tiles__tile').fadeIn(300);
});